import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { clientActions, clientSelectors } from "../../../ducks/client";
import { Group, groupActions } from "../../../ducks/group";
import { useNavigation } from "../../../hooks/useNavigation";
import { AppDispatch } from "../../../store";

export const useGroupEdit = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();
  const { groupId } = useParams<{ groupId: string }>();

  const clients = useSelector(clientSelectors.clients);
  const [group, setGroup] = useState<Group | null>(null);

  useEffect(() => {
    if (group || !groupId) return;

    dispatch(appActions.showLoading());

    dispatch(
      clientActions.fetchClients.started({
        sort_key: "id",
        sort_order: "asc",
        onError: () => dispatch(appActions.hideLoading()),
        onSuccess: () => {
          dispatch(
            groupActions.getGroupDetails.started({
              groupId,
              onComplete: () => dispatch(appActions.hideLoading()),
              onSuccess: (data) => {
                const groupData = data.data;
                const group: Group = {
                  id: groupData.id,
                  name: groupData.name,
                  clientName: groupData.customer_name,
                  createdAt: new Date(groupData.created_at),
                  createdBy: groupData.created_by,
                };

                setGroup(group);
              },
              onError: () => {
                navigateToPage(PageRoutes.GROUPS);
              },
            }),
          );
        },
      }),
    );
  }, []);

  const handleCancel = useCallback(() => {
    dispatch(
      appActions.showModal({
        title: "内容は保存されません。よろしいですか？",
        buttons: [
          {
            variant: "dark",
            text: "閉じる",
            onClick: () => {
              dispatch(appActions.hideModal());
            },
          },
          {
            variant: "filled",
            text: "保存しない",
            onClick: () => {
              dispatch(appActions.hideModal());
              navigateToPage(PageRoutes.GROUPS);
            },
          },
        ],
      }),
    );
  }, []);

  const handleEditGroup = useCallback(
    (customerId: string, name: string) => {
      if (!groupId) return;

      dispatch(appActions.showLoading());

      dispatch(
        groupActions.updateGroup.started({
          groupId,
          customer_id: customerId,
          name,
          onComplete: () => dispatch(appActions.hideLoading()),
          onSuccess: () => {
            dispatch(
              appActions.showNotification({
                message: "グループを更新しました",
                type: "success",
              }),
            );
            navigateToPage(PageRoutes.GROUPS);
          },
        }),
      );
    },
    [groupId],
  );

  return { clients, group, handleCancel, handleEditGroup };
};
